import { render, staticRenderFns } from "./TopBar.component.vue?vue&type=template&id=49d15da4&scoped=true&lang=pug"
import script from "./TopBar.component.vue?vue&type=script&lang=ts"
export * from "./TopBar.component.vue?vue&type=script&lang=ts"
import style0 from "./TopBar.component.vue?vue&type=style&index=0&id=49d15da4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d15da4",
  null
  
)

export default component.exports